import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-resumeLoadButton',
    template: `
    <button title="Link attachments to cases" (click)="linkAttachmentsToCasesButton($event);"
            class="btn btn-outline btn-success btn-rounded btn-sm waves-effect waves-light"  [disabled]="params.node.data.isSetIdIsNegativeFloat"
            style="padding: .3rem .8rem;margin-top:0rem">
      <i class="fas fa-link"></i>
    </button>`,
    standalone: false
})
export class LinkToCasesButton implements ICellRendererAngularComp {

  params;
  label: string;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  linkAttachmentsToCasesButton($event) {
    console.log("hello")
    if (this.params.linkAttachmentsToCasesButton instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        param:this.params
        // ...something
      }
      console.log(params)
      this.params.linkAttachmentsToCasesButton(params);

    }
  }
}
